import { Filtro } from "./Filtro";

export class TipoNovedadDTO {
    id:             string;
    descripcion:    string;
    descripcionNovedadTipo: string;
    descripcionEtiquetas: string[];
    roles:          number[];
    etiquetas:      string[];
    filtros:        Filtro[];
    usuariosAccion: string[];
    descripcionUsuariosAccion: string[];
}
